module.exports = {
  env: 'production',
  sentry: {
    environment: 'production',
    dsn: 'https://bcdc8ee782d2ab8d7bf73b9734455543@o4505941942796288.ingest.us.sentry.io/4505945535086592',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyB2syCCztBmLeaBNFqJ_1_H2jGAkJr8Xcs',
    authDomain: 'alux-61d7f.firebaseapp.com',
    projectId: 'alux-61d7f',
    storageBucket: 'alux-61d7f.appspot.com',
    messagingSenderId: '35963525157',
    appId: '1:35963525157:web:8994e4a56c91222b7347cc',
    measurementId: 'G-9F3CSTPCXW',
  },
  customerIo: {
    workspaceId: '134843',
  },
  mixpanel: {
    projectId: '2972527',
    viewId: '3491911',
  },
  revenueCat: {
    projectId: 'c0f48d41',
  },
  socialPlus: {
    dailySessionNetworkId: '6a75feff0dc0aa0827fd4bac',
    dailySessionNetworkName: 'Daily Dives',
  },
  s3: {
    publicBucket: 'https://alux-public-bucket.s3.amazonaws.com/',
    assetBuckets: {
      region: 'us-east-1',
      accessKey: 'AKIA3IYXAIIMIDBM42S4',
      secretAccessKey: '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',
      imagesBucket: 'alux-resizing-bucket',
      mediaBucket: 'alux-private-bucket',
    },
  },
};
